import { Component, Input } from '@angular/core';
import { ToggleComponent } from './toggle.component';

@Component({
  selector: 'app-toggle-button',
  template:
  '<button class="widget-toolbar-btn-old" (on)="toggle.on" (click)="onClick()">' +
  '<ng-content></ng-content>' +
  '</button>',
  styleUrls: ['../../widget.scss']
  })

export class ToggleButtonComponent {
  @Input() callbackOnToggle: any;

  constructor(public toggle: ToggleComponent) { }

  /**
   * Callback handler for onClick.
   */
  onClick() {
    const on = !this.toggle.on;
    this.callbackOnToggle(on);
    this.toggle.setOnState(on);
  }
}
